import PropTypes from 'prop-types'
import NoContentHistoricIcon from './no_content.svg';
import {
  StyledContainer,
  StyledTitle,
  StyledEmptyMessageContainer,
  StyledEmptyIcon,
  StyledEmptyText,
  StyledTopContainerEmpty,
  StyledHeaderEmpty
} from './styled-components'

const HistoricSalesEmpty = ({ t }) => (
  <StyledContainer>
    <StyledTopContainerEmpty>
      <StyledHeaderEmpty>
        <StyledTitle>{t('subscriptionTools:historic_contracts.module_title')}</StyledTitle>
      </StyledHeaderEmpty>
    </StyledTopContainerEmpty>
    <StyledEmptyMessageContainer>
      <StyledEmptyIcon src={NoContentHistoricIcon} alt="No historic content" />
      <StyledEmptyText>
        {t('subscriptionTools:historic_contracts.empty_text')}
      </StyledEmptyText>
    </StyledEmptyMessageContainer>
  </StyledContainer>
);

HistoricSalesEmpty.propTypes = {
  t: PropTypes.func,
}

export default HistoricSalesEmpty;
